// extracted by mini-css-extract-plugin
export default {"group":"TableController_group__PEEn+"};